export const encyclopediaPtBR = {
  // Compartilhado
  'encyclopedia.lockAria': 'Bloqueado — desbloqueie para ler',

  // EncyclopediaPage
  'encyclopedia.page.seoTitle': 'A Enciclopédia',
  'encyclopedia.page.seoDescription':
    'Procure no grimório vivo de Grymwyrd — monstros, magias, espécies, itens, locais e muito mais.',
  'encyclopedia.page.heading': 'A Enciclopédia',
  'encyclopedia.page.subtitle': 'O grimório vivo de todos os horrores, magias e lendas de Grymwyrd.',
  'encyclopedia.page.searchPlaceholder': 'Procurar {plural}…',
  'encyclopedia.page.searchAria': 'Procurar {plural}',
  'encyclopedia.page.clearSearch': 'Limpar busca',
  'encyclopedia.page.systemNotLivePrefix': 'O Véu ainda não se abriu para',
  'encyclopedia.page.systemNotLiveSuffix':
    '. Nenhuma tradição ligada a este rito vaza através — seu grimório aguarda além da escuridão.',
  'encyclopedia.page.returnToAllSystems': 'Voltar a todos os sistemas',
  'encyclopedia.page.settingNotLivePrefix': 'As terras de',
  'encyclopedia.page.settingNotLiveSuffix':
    ' ainda estão sendo mapeadas — suas entradas ainda não estão ligadas ao cenário. Até os cartógrafos terminarem, nada responde aqui.',
  'encyclopedia.page.returnToAllRealms': 'Voltar a todos os reinos',
  'encyclopedia.page.filteringBy': 'Filtrando por',
  'encyclopedia.page.filterSystem': 'sistema "{label}"',
  'encyclopedia.page.filterCanon': 'camada canônica "{label}"',
  'encyclopedia.page.filterSetting': 'cenário "{label}"',
  'encyclopedia.page.canonNote': 'A camada canônica se aplica quando as entidades são marcadas na API (ver _docs/13). ',
  'encyclopedia.page.clear': 'Limpar',
  'encyclopedia.page.hide': 'Ocultar',
  'encyclopedia.page.filter': 'Filtrar',

  // EntityCard
  'encyclopedia.entityCard.unlockAria': 'Desbloquear {name} (conteúdo Grymwyrd)',
  'encyclopedia.entityCard.viewAria': 'Ver entrada {name}',

  // EntityGrid
  'encyclopedia.grid.paginationAria': 'Paginação ({position})',
  'encyclopedia.grid.prev': 'Anterior',
  'encyclopedia.grid.next': 'Próximo',
  'encyclopedia.grid.pageOf': 'Página {page} de {totalPages}',
  'encyclopedia.grid.resultsAria': '{plural} resultados',
  'encyclopedia.grid.scrying': 'Consultando os arquivos…',
  'encyclopedia.grid.count': '{total} {plural}',
  'encyclopedia.grid.sortDescAria': 'Ordenar descendente',
  'encyclopedia.grid.sortAscAria': 'Ordenar ascendente',
  'encyclopedia.grid.sortAZ': 'A–Z',
  'encyclopedia.grid.sortZA': 'Z–A',
  'encyclopedia.grid.viewModeAria': 'Modo de visualização',
  'encyclopedia.grid.gridViewAria': 'Visualização em grade',
  'encyclopedia.grid.listViewAria': 'Visualização em lista',
  'encyclopedia.grid.jumpToLetterAria': 'Pular para letra',
  'encyclopedia.grid.all': 'Todos',
  'encyclopedia.grid.letterSymbolAria': 'Entradas começando com número ou símbolo',
  'encyclopedia.grid.letterAria': 'Entradas começando com {letter}',
  'encyclopedia.grid.emptyTitle': 'O Arquivo Está em Silêncio',
  'encyclopedia.grid.emptyForLetter': 'Nenhum {plural} leva um nome começando com "{letter}".',
  'encyclopedia.grid.emptyAll': 'Nenhum {plural} responde seu chamado.',
  'encyclopedia.grid.turningPages': 'Virando páginas…',

  // EntityImage
  'encyclopedia.entityImage.noArtworkAria': '{label} (sem ilustração)',
  'encyclopedia.entityImage.noVision': 'Sem Visão',

  // FacetSidebar
  'encyclopedia.facets.all': 'Todos',
  'encyclopedia.facets.soon': 'Em Breve',
  'encyclopedia.facets.navAria': 'Filtros de tipo de entidade',
  'encyclopedia.facets.clearAll': 'Limpar todos os filtros',
  'encyclopedia.facets.lorebook': 'Grimório',
  'encyclopedia.facets.gameSystem': 'Sistema de Jogo',
  'encyclopedia.facets.canonLayer': 'Camada Canônica',
  'encyclopedia.facets.setting': 'Cenário',

  // GlobalSearch
  'encyclopedia.globalSearch.title': 'Procurar no Véu',
  'encyclopedia.globalSearch.placeholder': 'Procurar monstros, magias, locais, tradições…',
  'encyclopedia.globalSearch.queryAria': 'Consulta de busca',
  'encyclopedia.globalSearch.loading': 'Consultando…',
  'encyclopedia.globalSearch.empty': 'Nada se mexe na escuridão para "{q}".',

  // LockedContent — LockBadge
  'encyclopedia.lockBadge.title': 'Conteúdo Grymwyrd — desbloqueie para ler',
  'encyclopedia.lockBadge.label': 'Bloqueado',
  // LockedContent — LockedGate
  'encyclopedia.lockedGate.regionAria': 'Conteúdo bloqueado',
  'encyclopedia.lockedGate.defaultTitle': 'Esta tradição está lacrada',
  'encyclopedia.lockedGate.body':
    'O bestiário, as magias e as lendas de Grymwyrd estão ligadas ao Cataclismo Grymwyrd. O canon aberto SRD permanece livre — mas para caminhar o próprio crepúsculo eterno, adquira o livro.',
  'encyclopedia.lockedGate.unlockCta': 'Desbloquear Grymwyrd',
  'encyclopedia.lockedGate.signInCta': 'Já é um apoiador? Entre em sua conta',
  'encyclopedia.lockedGate.backerNote':
    'Os apoiadores que se comprometeram com Grymwyrd já possuem isso — entre em sua conta para desbloqueá-lo.',

  // TableView
  'encyclopedia.table.rollToastTitle': '{name} — rolou {total}',
  'encyclopedia.table.noRowMatched': 'Nenhuma linha correspondeu a {total}.',
  'encyclopedia.table.loading': 'Desdobrando a tabela…',
  'encyclopedia.table.error': 'Esta tabela não pôde ser desenhada.',
  'encyclopedia.table.roll': 'Rolar {formula}',
  'encyclopedia.table.lastRoll': 'Último rolar: {value}',
  'encyclopedia.table.noMatchingRow': ' · nenhuma linha correspondente',

  // EntityDetailPage
  'encyclopedia.detail.entryFallback': 'Entrada',
  'encyclopedia.detail.addedToCampaign': 'Adicionado à sua campanha.',
  'encyclopedia.detail.addError': 'Não foi possível acessar o cofre da campanha. Tente novamente mais tarde.',
  'encyclopedia.detail.unknownType': 'Tipo de entrada desconhecido.',
  'encyclopedia.detail.seoDescription': '{name} — um {label} na Enciclopédia Grymwyrd.',
  'encyclopedia.detail.breadcrumbAria': 'Breadcrumb',
  'encyclopedia.detail.breadcrumbRoot': 'Enciclopédia',
  'encyclopedia.detail.sourceVersionAria': 'Versão da fonte',
  'encyclopedia.detail.versionConsolidated': 'Consolidado',
  'encyclopedia.detail.versionBook': 'Livro Específico',
  'encyclopedia.detail.removeBookmarkAria': 'Remover marcador',
  'encyclopedia.detail.addBookmarkAria': 'Adicionar marcador',
  'encyclopedia.detail.bookmarked': 'Marcado',
  'encyclopedia.detail.bookmark': 'Marcador',
  'encyclopedia.detail.addToCampaign': 'Adicionar à Campanha',
  'encyclopedia.detail.sealedTitle': '{name} está lacrado',
  'encyclopedia.detail.bookVariantNote':
    'Mostrando o registro consolidado; o texto variante por livro aparecerá aqui quando as edições do livro estiverem vinculadas.',
  'encyclopedia.detail.tablistAria': 'Seções da entrada',
  'encyclopedia.detail.tab.lore': 'Tradição',
  'encyclopedia.detail.tab.stats': 'Atributos',
  'encyclopedia.detail.tab.gallery': 'Galeria',
  'encyclopedia.detail.tab.relations': 'Relações',
  'encyclopedia.detail.tab.discussions': 'Discussões',
  'encyclopedia.detail.tab.claims': 'Reclamações de Jogador',
  'encyclopedia.detail.loading': 'Despertando a entrada…',

  // tabs/LoreTab
  'encyclopedia.lore.loading': 'Desenterrando as tradições…',
  'encyclopedia.lore.empty': 'As histórias desta entrada permanecem não escritas.',

  // tabs/StatsTab
  'encyclopedia.stats.loading': 'Lendo as runas…',
  'encyclopedia.stats.empty': 'Nenhuma mecânica é registrada para esta entrada.',

  // tabs/GalleryTab
  'encyclopedia.gallery.loading': 'Desenvolvendo as visões…',
  'encyclopedia.gallery.emptyTitle': 'Nenhuma Visão Ainda',
  'encyclopedia.gallery.emptyBody': 'Nenhuma ilustração foi vinculada a esta entrada. Contribua uma no Cofre.',
  'encyclopedia.gallery.artworkAlt': 'Ilustração da entidade',

  // tabs/DiscussionsTab
  'encyclopedia.discussions.loading': 'Reunindo sussurros…',
  'encyclopedia.discussions.emptyTitle': 'Silêncio nos Corredores',
  'encyclopedia.discussions.emptyBody': 'Seja o primeiro a discutir esta entrada com outros viajantes.',
  'encyclopedia.discussions.startCta': 'Iniciar uma Discussão',
  'encyclopedia.discussions.untitledThread': 'Thread sem título',
  'encyclopedia.discussions.byAuthor': 'por {author}',
  'encyclopedia.discussions.replyCount': '{count} respostas',

  // tabs/ClaimsTab
  'encyclopedia.claims.recorded': 'Sua reclamação foi registrada para revisão.',
  'encyclopedia.claims.recordError': 'Os escribas não puderam registrar sua reclamação. Tente novamente mais tarde.',
  'encyclopedia.claims.loading': 'Consultando o canon…',
  'encyclopedia.claims.emptyTitle': 'Nenhuma Reclamação de Jogador Ainda',
  'encyclopedia.claims.emptyBody': 'Nenhum viajante ainda teceu sua lenda nesta entrada.',
  'encyclopedia.claims.claimCta': 'Reivindicar isto',
  'encyclopedia.claims.signInCta': 'Entre em sua conta para fazer uma reclamação',
  'encyclopedia.claims.untitledClaim': 'Reclamação sem título',
  'encyclopedia.claims.byAuthor': 'por {author}',
  'encyclopedia.claims.addCta': 'Adicione sua reclamação',

  // tabs/RelationsTab
  'encyclopedia.relations.thisEntry': 'Esta Entrada',
  'encyclopedia.relations.relationLabel': 'Relação {index}',
  'encyclopedia.relations.kindredLabel': 'Parente {index}',
  'encyclopedia.relations.loading': 'Traçando os fios do destino…',
  'encyclopedia.relations.hintIntro': 'Clique em um nó para viajar para essa entrada. Os fios mostrados são',
  'encyclopedia.relations.hintCanonical': ' relações canônicas.',
  'encyclopedia.relations.hintKindred': ' parentes do mesmo tipo.',
} as const
